import { defineStore } from "pinia";
type FinallyStore = {
    consent: boolean | null,
    email: boolean,
    telephone: boolean,
    personalizedOnlineMarketing: boolean,
    post: boolean,
}

export const useFinallyStore = defineStore("finally", {
    state: () : FinallyStore => {
        return {
            consent: null,
            email: false,
            telephone: false,
            personalizedOnlineMarketing: false,
            post: false,
        };
    },
    getters: {
        getMarketingInformation: (state) => {
            return {
                "email-marketing": state.email ? "yes" : "no",
                "telephone-marketing": state.telephone ? "yes" : "no",
                "online-marketing": state.personalizedOnlineMarketing ? "yes" : "no",
                "post-marketing": state.post ? "yes" : "no",
            };
        },
    },
});
